import PropTypes from 'prop-types';

const EventItem = (props) => {
  const {
    type,
    eventName,
    eventDate,
    eventRstCode,
    eventResorts,
    customRstInfo,
    images,
    mediaId,
    description,
    resortInfoPlaceholder,
    onLearMore,
    externalLink,
    eventId
  } = props;

  const { resortSummary = {} } = window.beaches_app.page;
  const resortInfo = resortSummary[eventRstCode] || {};

  const {
    resortShortName = resortInfoPlaceholder,
    resortCountry = '',
    resortCity = ''
  } = resortInfo;

  const imgPlaceholder = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mO8/R8AArsB3IYZcW4AAAAASUVORK5CYII=';
  const errorHandler = (e) => {
    e.target.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', imgPlaceholder);
  };
  const imageElement = (
    <svg >

      <image
        onError={errorHandler}
        width="100%"
        height="100%"
        xlinkHref={`https://ers.sandals.com/v1/event/media/image/?mediaId=${mediaId}` || imgPlaceholder}
        clipPath="url(#clipPath)" />
    </svg>
  );
  let moreBtn = <button className="more-btn" onClick={onLearMore}>learn more</button>;
  let learnMoreBtn = <button className="learnMore-btn" onClick={onLearMore}>learn more</button>;
  let shortDescription = description && description.substring(0, 200) + '...';
  const eventsWithoutButton = [85, 87, 46587341, 46587342];

  if (externalLink) {
    moreBtn = <a href={externalLink + '/'} className="more-btn">learn more</a>;
    learnMoreBtn = <a href={externalLink + '/'} className="learnMore-btn">learn more</a>;
  }
  // Conditional for events with long description and without learn more button.
  if(eventsWithoutButton.includes(eventId)) {
    moreBtn = '';
    shortDescription = description;
  }

  return(
    <article className={`article ${type}`}>
      {imageElement}

      <div className="content">
        <h2 className="title-1">{eventName}</h2>

        <p>{shortDescription}</p>
        {learnMoreBtn}
      </div>
      <div className="aside">
        <div className="column">
          <h2 class="dates">Event Date</h2>
          {eventDate && <h2 className="title-4">{eventDate}</h2>}
          <h2 class="dates">Location</h2>
          <h3 className="title-5">
            {(eventResorts && resortInfoPlaceholder) ||
              (resortCity && resortCountry && `${resortCity}, ${resortCountry}`)}
          </h3>
        </div>

        {moreBtn}
      </div>
    </article>
  );
};

EventItem.propTypes = {
  type: PropTypes.string,
  eventName: PropTypes.string,
  eventDate: PropTypes.string,
  eventRstCode: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array
  ]),
  eventResorts: PropTypes.array,
  groupName: PropTypes.string,
  images: PropTypes.object,
  description: PropTypes.string,
  externalLink: PropTypes.string,
};

EventItem.defaultProps = {
  type: '',
  eventName: '',
  eventDate: '',
  eventRstCode: '',
  description: '',
  images: {}
};

export default EventItem;
